var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 8.27501C27.0997 8.66618 26.1472 8.9239 25.1725 9.04001C26.1968 8.4402 26.9672 7.48729 27.339 6.36001C26.3705 6.9263 25.3128 7.32364 24.211 7.53501C23.2734 6.55238 21.9737 5.9975 20.6155 6.00001C17.8945 6.00001 15.6925 8.17001 15.6925 10.845C15.6906 11.2171 15.7332 11.5881 15.8195 11.95C11.8742 11.7651 8.18944 9.9263 5.6695 6.88501C5.23229 7.62207 5.00107 8.46303 5 9.32001C5 11 5.8765 12.485 7.2 13.355C6.41586 13.3364 5.6478 13.1289 4.961 12.75V12.81C4.961 15.16 6.661 17.115 8.911 17.56C8.48789 17.6728 8.05188 17.7299 7.614 17.73C7.30329 17.7305 6.99328 17.7004 6.6885 17.64C7.314 19.565 9.1345 20.965 11.291 21.005C9.53869 22.3555 7.38731 23.0854 5.175 23.08C4.78231 23.0794 4.38998 23.0561 4 23.01C6.25059 24.4471 8.86672 25.2073 11.537 25.2C20.605 25.2 25.559 17.815 25.559 11.41C25.559 11.2 25.5535 10.99 25.5435 10.785C26.505 10.101 27.3369 9.25106 28 8.27501Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.9444629192faa3b8142266cc20ab353d.svg";
export { ForwardRef as ReactComponent };